import React from 'react';
import { PlayCircle, CheckCircle2, Percent } from 'lucide-react';

const Stat = ({ icon, label, value, sub, testId }) => (
  <div className="bg-slate-900/50 rounded-lg p-4 border border-slate-700">
    <div className="flex items-center gap-2 mb-2">
      {icon}
      <span className="text-slate-400 text-sm">{label}</span>
    </div>
    <p className="text-2xl font-bold text-white" data-testid={testId}>{value}</p>
    {sub && <p className="text-xs text-slate-500 mt-1">{sub}</p>}
  </div>
);

export const TrailerStats = ({ trailer }) => {
  const w = trailer?.week || {};
  const a = trailer?.all_time || {};
  return (
    <div className="mb-6" data-testid="trailer-stats">
      <h3 className="text-sm font-medium text-slate-400 mb-3">Landing Page Trailer (last 7 days)</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Stat icon={<PlayCircle className="w-4 h-4 text-emerald-400" />} label="Pressed Play"
          value={w.unique_plays || 0} sub={`${w.plays || 0} total plays · ${a.unique_plays || 0} all time`}
          testId="trailer-plays" />
        <Stat icon={<CheckCircle2 className="w-4 h-4 text-amber-400" />} label="Watched to the End"
          value={w.unique_completes || 0} sub={`${w.completes || 0} total · ${a.unique_completes || 0} all time`}
          testId="trailer-completes" />
        <Stat icon={<Percent className="w-4 h-4 text-cyan-400" />} label="Finish Rate"
          value={`${w.completion_rate || 0}%`} sub="of visitors who pressed play"
          testId="trailer-completion-rate" />
      </div>
    </div>
  );
};
